<template>
  <apexchart type="line" :options="chartOptions" :height="300" :series="series"></apexchart>
</template>

<script>
export default {
  name: 'BaseLineChart',
  props: {
    series: { type: Array, default: () => []},
    categories: { type: Array, default: () => [] }
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          height: "300px"
        },
        xaxis: {
          categories: this.categories,
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true
          }
        },
        markers: { size: 5, shape: 'circle' }
      }
    }
  }

}
</script>

<style>

</style>
